<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import './assets/css/color.less';

@layout-header-background: #5182e4;
@primary-color: #5182e4;
@link-color: #5182e4;

html, body, #app {
  width: 100%;
  min-height: 100%;
}

html {
  font-size: 16px; /* 默认基准字体大小 */

  @media (min-width: 1920px) {
    font-size: 16px; /* 保持大屏的基准字体大小 */
  }

  @media (min-width: 1200px) and (max-width: 1919px) {
    font-size: 14px; /* 中等屏幕的基准字体大小 */
  }

  @media (max-width: 1199px) {
    font-size: 12px; /* 小屏幕的基准字体大小 */
  }
}

.ivu-card {
  margin-bottom: 20px;
}

.ivu-page {
  margin-top: 8px;
  padding-left: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue